import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=44daf990&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=ts&"
export * from "./Orders.vue?vue&type=script&lang=ts&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=44daf990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44daf990",
  null
  
)

export default component.exports